module.exports = __webpack_public_path__ + "static/img/3-6.11.5.ffc3566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.11.5.png
// module id = RKBX
// module chunks = 0